var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowFilledRight = function SvgIconArrowFilledRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.264 4.493H1.108a.8.8 0 0 0-.8.8v3.4a.8.8 0 0 0 .8.8h9.156v3.11a.4.4 0 0 0 .663.3l6.075-5.307a.8.8 0 0 0 0-1.205l-6.075-5.296a.4.4 0 0 0-.663.302v3.098-.002Z",
    fill: "url(#icon-arrow-filled-right_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-arrow-filled-right_svg__a",
    x1: 0,
    y1: 7,
    x2: 18,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DFF"
  })))));
};
export default SvgIconArrowFilledRight;